<template>
    <el-container>
        <div class="container">
            <div class="searchBox">
                <el-form :inline="true" :model="formData" label-option="left">
                    <el-row >
                        <el-col :span="8" class="leftAlignTtem">
                            <el-form-item label="维保员工">
                                <el-autocomplete :popper-append-to-body="false"
                                v-model="formData.maintainer" :fetch-suggestions="queryMaintainer">
                                </el-autocomplete >
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="leftAlignTtem">
                            <el-form-item label="维保合约">
                               <el-input v-model="formData.contractNo" placeholder="合约号" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="leftAlignTtem">
                            <el-form-item label="作番号">
                                <el-input v-model="formData.mfgNo" placeholder="作番号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8" class="leftAlignTtem">
                        <el-form-item label="合约类型">
                          <el-select v-model="formData.contractType" placeholder="请选择合约类型" :popper-append-to-body="false">
                            <el-option label="全部" value="0"  key="0"/>
                            <el-option label="直销" value="1"  key="1"/>
                            <el-option label="平台" value="2"  key="2"/>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" class="leftAlignTtem">
                         <el-form-item label="维保月份">
                          <div class="my-date-picker-wrapper" id="my-date-picker-div">
                            <el-date-picker v-model="formData.yearMonth" type="month" placeholder="选择月份" format="yyyy-MM" value-format="yyyy-MM" :picker-options="pickerOptions" :popper-append-to-body="false"  popper-class="custom-picker-popper" ref="myDatePicker"></el-date-picker>
                          </div>
                         </el-form-item>
                      </el-col>
                      <el-col :span="8" class="leftAlignTtem">
                        <el-form-item label="分公司">
                           <el-select v-model="formData.fcunit" placeholder="请选择分公司" :popper-append-to-body="false">
                              <el-option label="全部" value=""  key="0"/>
                              <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="16" class="leftAlignTtem">
                         <el-button type="primary" @click="query" >查询</el-button>
                         <el-button type="success" @click="exportExcel(false)" >导出报表</el-button>
                         <el-button type="danger" @click="handleDialogOpen" >新增</el-button>

                         <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :action="uploadUrl"
                                    :headers="headerObj"
                                    :on-success="handleUploadSuccess"
                                     accept=".xls,.xlsx"
                                     >
                                        <el-button  type="success" >点击导入</el-button>
                         </el-upload>
                         <el-form-item label="显示明细">
                          <el-switch
                          v-model="showDetail"
                          active-color="#13ce66"
                          inactive-color="#ff4949" @change="handleSwitchChange">
                        </el-switch>
                        </el-form-item>

                        <el-link style="margin-left: 10px; color:green" :href="templateUrl" >点击下载导入模板</el-link>
                      </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="calender-wrapper">
                <div class="summary-bar">
                  <div class="summary-item">
                    <span class="label">维保电梯台数：</span>
                    <span class="value">{{ queryResult.mfgCount }}</span>
                  </div>
                  <div class="summary-item">
                    <span class="label">月度维保次数：</span>
                    <span class="value">{{ queryResult.taskCount }}</span>
                  </div>
                  <div class="summary-item">
                    <span class="label">当月已完成:</span>
                    <span class="value">{{ queryResult.finishedTaskCount }}</span>
                  </div>
                  <div class="summary-item">
                    <span class="label" style="color:red">逾期未完成:</span>
                    <span class="value" ><el-link style="color:red ;font-size: 24px;font-weight: bold; text-decoration: underline;" @click="handleLinkClick">{{ queryResult.delayTaskCount }}</el-link></span>
                  </div>
                  <div class="summary-item progress-item">
                     <span class="label">维保达成率:</span>
                     <el-progress
                      :percentage="queryResult.completionRate"
                      :stroke-width="18"
                      :text-inside="true"
                      :color="progressColors"
                      style="width: 300px;"
                      ></el-progress>
                  </div>
                </div>
                <el-calendar v-model="queryMonth" :style="{ '--day-height': dayHeight + 'px' }" >
                  <template slot="dateCell" slot-scope="{date, data}">
                    <div v-show="isCurrentMonth(data.day)" @click="handleDateClick(data)">
                    <p style="font-weight: bold;">{{ data.day.split('-')[1]+"-"+data.day.split('-')[2] }}</p>

                    <p style="color: rgb(64, 158, 255)">总任务:{{ calendarData[data.day] ? calendarData[data.day].mfgTotalCount : 0 }}</p>
                    <p v-show="showDetail" style="color:crimson">待签到:{{ calendarData[data.day] ? calendarData[data.day].taskStatus0Count : 0 }} </p>
                    <p v-show="showDetail" style="color:goldenrod">待接手:{{ calendarData[data.day] ? calendarData[data.day].taskStatus1Count : 0 }} </p>
                    <p v-show="showDetail" style="color:lightslategray">待签退:{{ calendarData[data.day] ? calendarData[data.day].taskStatus3Count : 0 }} </p>
                    <p style="color:green">已完成:{{ calendarData[data.day] ? calendarData[data.day].taskStatus2Count : 0 }} </p>
                    <p v-show="showDetail" style="color:magenta">未指派:{{ calendarData[data.day] ? calendarData[data.day].taskStatusNullCount : 0 }}</p>

                    <p>任务完成率:{{ calendarData[data.day] ? calendarData[data.day].finishRate : 0 }}%</p>
                    </div>
                  </template>
                </el-calendar>
                <el-dialog
                  :visible.sync="addDialogVisible"
                  width="30%"
                  title="新增维保计划"
                  :modal="true"
                  :draggable="true"
                  :close-on-click-modal="false"
                  :before-close="handleDialogClose"
                >
                <el-form ref="addForm" :model="addFormData" label-width="100px">
                  <el-row style="margin-top: 20px;">
                    <el-col :span="24" class="leftAlignTtem">
                      <el-form-item label="作番号">
                        <el-input v-model="addFormData.mfgNos" placeholder="作番号 可以一次性填多个 用空格隔开"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="leftAlignTtem">
                      <el-form-item label="保养日期">
                        <el-date-picker v-model="addFormData.taskDeadLine" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  :picker-options="pickerOptions1"  :popper-append-to-body="false"  popper-class="custom-picker-popper1" ref="myDatePicker1"></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="leftAlignTtem">
                      <el-form-item label="维保员工">
                                <el-autocomplete :popper-append-to-body="false"
                                  v-model="addFormData.maintainer" :fetch-suggestions="queryMaintainer">
                                </el-autocomplete >
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="handleAdd" >确定</el-button>
                  <el-button @click="handleDialogClose">取消</el-button>
                </div>
                </el-dialog>
            </div>
        </div>

    </el-container>
</template>

<script>
import request from '@/lib/utils'
export default {
  name: 'SignPlan',
  data () {
    return {
      formData: {
        maintainer: '',
        contractNo: '',
        contractType: '',
        mfgNo: '',
        yearMonth: '',
        fcunit: ''
      },
      maintainers: [],
      companies: [],
      pickerOptions: {
        disabledDate (time) {
          const currentDate = new Date()
          const currentMonthFirstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
          return time.getTime() > currentMonthFirstDay.getTime()
        }
      },
      pickerOptions1: {
        disabledDate (time) {
          const currentDate = new Date()
          const currentMonthFirstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
          return time.getTime() < currentMonthFirstDay.getTime()
        }
      },
      queryResult: {
        mfgCount: 0,
        taskCount: 0,
        finishedTaskCount: 0,
        delayTaskCount: 0,
        completionRate: 60
      },
      progressColors: [
        { color: '#F56C6C', percentage: 30 },
        { color: '#E6A23C', percentage: 50 },
        { color: '#67C23A', percentage: 100 }
      ],
      calendarData: {

      },
      queryMonth: '',
      dayHeight: '120',
      showDetail: false,
      intervalHandler: null,
      addDialogVisible: false,
      addFormData: {
        mfgNos: '',
        taskDeadLine: '',
        maintainer: ''
      },
      uploadUrl: process.env.API_URL + 'mfgManager/uploadMaintainTask',
      headerObj: {
        'auth-token': ''
      },
      templateUrl: process.env.API_URL + 'static/template/task.xlsx'
    }
  },
  methods: {
    initMaintainer () {
      request.get('/mfgManager/queryBriefMaintainer').then(res => {
        this.maintainers = res.obj
      })
    },
    queryMaintainer (queryString, cb) {
      let searchResults = this.maintainers
      searchResults = queryString ? searchResults.filter(item => item.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || item.workNo.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : searchResults
      let cbResults = searchResults.map(item => {
        item.value = item.name + '(' + item.workNo + ')'
        return item
      })
      // console.log(cbResults)
      cb(cbResults)
    },
    isCurrentMonth (day) {
      if (typeof this.queryMonth === 'string') {
        return day.substring(0, 7) === String(this.queryMonth).substring(0, 7)
      } else {
        if (this.queryMonth instanceof Date) {
          let queryMonthStr = this.queryMonth.getFullYear() + '-' + String(this.queryMonth.getMonth() + 1).padStart(2, '0')
          return day.substring(0, 7) === queryMonthStr.substring(0, 7)
        }
        return true
      }
    },
    query () {
      if (this.formData.yearMonth) {
        this.queryMonth = this.formData.yearMonth
      }
      const postObj = {
        'maintainer': this.formData.maintainer,
        'contractNo': this.formData.contractNo,
        'contractType': this.formData.contractType,
        'mfgNo': this.formData.mfgNo,
        'yearMonth': this.queryMonth,
        'subCompany': this.formData.fcunit
      }
      request.post('/mfgManager/queryMfgMaintainTaskMonthReport', postObj).then(

        res => {
          this.queryResult.mfgCount = res.obj.mfgCount
          this.queryResult.taskCount = res.obj.taskCount
          this.queryResult.finishedTaskCount = res.obj.finishedTaskCount
          this.queryResult.delayTaskCount = res.obj.delayTaskCount
          this.queryResult.completionRate = res.obj.completionRate
          this.calendarData = res.obj.dayReportMap
        }
      )
    },
    initCompany () {
      request.get('/mfgManager/queryAllSubCompany').then(
        res => {
          this.companies.splice(0, this.companies.length)
          for (let item of res.obj) {
            this.companies.push({'id': item.depart_no, 'name': item.depart_name})
          }
        }
      )
    },
    exportExcel (filterDelay) {
      let token = localStorage.getItem('auth-token')
      let exportUrl = process.env.API_URL + 'sign/exportSignReportV2?auth_token=' + token
      if (this.formData.maintainer) {
        exportUrl = exportUrl + '&maintainer=' + this.formData.maintainer
      }
      if (this.formData.contractNo) {
        exportUrl = exportUrl + '&contractNo=' + this.formData.contractNo
      }
      if (this.formData.contractType) {
        exportUrl = exportUrl + '&contractType=' + this.formData.contractType
      }
      if (this.formData.mfgNo) {
        exportUrl = exportUrl + '&mfgNo=' + this.formData.mfgNo
      }
      if (typeof this.queryMonth === 'string') {
        exportUrl = exportUrl + '&yearMonth=' + this.formData.yearMonth
      }
      if (this.queryMonth instanceof Date) {
        let queryMonthStr = this.queryMonth.getFullYear() + '-' + String(this.queryMonth.getMonth() + 1).padStart(2, '0') + '-' + String(this.queryMonth.getDate()).padStart(2, '0')
        exportUrl = exportUrl + '&yearMonth=' + queryMonthStr
      }
      if (this.formData.fcunit) {
        exportUrl = exportUrl + '&subCompany=' + this.formData.fcunit
      }
      if (filterDelay) {
        exportUrl = exportUrl + '&filterDelay=true'
      }
      window.open(exportUrl, '_blank')
    },
    handleDateClick (data) {
      this.queryMonth = data.day
      this.$confirm('是否下载 ' + data.day + ' 的数据?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.exportExcel(false)
        })
        .catch(() => {

        })
    },
    handleLinkClick () {
      this.$confirm('是否下载逾期未保养的计划?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.exportExcel(true)
        })
        .catch(() => {

        })
    },
    handleSwitchChange (value) {
      if (value) {
        this.dayHeight = '220'
      } else {
        this.dayHeight = '120'
      }
    },
    updatePopperPos () {
      // 自动在狭窄屏幕调整弹出框位置的函数 无业务意义
      let zoomRate = 1
      if (document.body.style.zoom) {
        zoomRate = document.body.style.zoom
      }
      console.log('zoomRate : ', zoomRate)
      const pickerEl = this.$refs.myDatePicker && this.$refs.myDatePicker.$el
      if (pickerEl) {
        const inputEl = pickerEl.querySelector('input')
        if (inputEl) {
          const rect = inputEl.getBoundingClientRect()
          const absoluteX = rect.left + window.scrollX
          const absoluteY = rect.top + window.scrollY
          // console.log(`绝对坐标: X=${absoluteX}, Y=${absoluteY}`)
          const targetDiv = document.querySelector('div.el-picker-panel.el-date-picker.el-popper.custom-picker-popper')
          if (targetDiv) {
            targetDiv.style.top = absoluteY / zoomRate + 40 + 'px'
            targetDiv.style.left = absoluteX / zoomRate + 'px'
            void targetDiv.offsetHeight
          }
        }
      }
      const picker1El = this.$refs.myDatePicker1 && this.$refs.myDatePicker1.$el
      if (picker1El) {
        const input1El = picker1El.querySelector('input')
        const rect1 = input1El.getBoundingClientRect()
        const absoluteX1 = rect1.left + window.scrollX
        const absoluteY1 = rect1.top + window.scrollY
        // console.log(`绝对坐标: X=${absoluteX}, Y=${absoluteY}`)
        const targetDiv1 = document.querySelector('div.el-picker-panel.el-date-picker.el-popper.custom-picker-popper1')
        if (targetDiv1) {
          targetDiv1.style.top = absoluteY1 / zoomRate + 40 + 'px'
          targetDiv1.style.left = absoluteX1 / zoomRate + 'px'
          void targetDiv1.offsetHeight
        }
      }
    },
    handleDialogClose () {
      this.addDialogVisible = false
    },
    handleDialogOpen () {
      this.addDialogVisible = true
    },
    handleAdd () {
      console.log('addFormData : ', this.addFormData)
      request.post('/mfgManager/addMaintainTask', this.addFormData).then(
        res => {
          this.$alert(res.code === 'success' ? res.obj : res.message, '提示', {
            confirmButtonText: '确定',
            callback: _action => {
              this.addDialogVisible = false
              this.addFormData = {}
            }
          }
          )
        }
      )
    },
    handleUploadSuccess (res, _file, _fileList) {
      let alertMsg = ''
      if (res.code === 'success') {
        alertMsg = res.obj
      } else {
        alertMsg = res.message
        this.$refs.upload.clearFiles()
      }
      this.$alert(alertMsg, '上传结果')
    }

  },
  mounted () {
    this.initMaintainer()
    this.initCompany()
    const now = new Date()
    this.queryMonth = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0')
    this.query()
    this.updatePopperPos()
    if (!this.intervalHandler) {
      this.intervalHandler = setInterval(this.updatePopperPos, 500)
    }
    this.headerObj['auth-token'] = localStorage.getItem('auth-token')
  },
  beforeDestroy  () {
    clearInterval(this.intervalHandler)
    this.intervalHandler = null
  }
}

</script>

<style scoped>

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 1200px;
    overflow-x: scroll;
  }

  .searchBox{
    width:80% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 80%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

  .shortInput{
    width: 30%;
  }

  .longInput{
    width: 390%;
  }

  .expandForm{
    margin-left: 30px;
  }
  .calender-wrapper{
    padding: 20px;
    width:80% ;
    min-width: 1200px;
  }

  .summary-bar {
  flex: 1; /* 每个卡片等宽 */
  background-color: rgb(64, 158, 255);
  border-radius: 6px;
  padding: 15px 20px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  box-shadow: 0 4px 6px rgba(75, 92, 196, 0.2);
}
.summary-item {
  display: flex;
  align-items: center;
  margin-right: 40px;
  border-left: 1px solid white;
  padding-left: 15px;
  margin-left: 15px;
}

.summary-item:first-child {
  border-left: none;
  padding-left: 0;
  margin-left: 0;
}

.summary-item .label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  margin-bottom: 8px;
}

.summary-item .value {
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
}

.progress-item {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

/deep/ .el-calendar-table .el-calendar-day {
  height: var(--day-height, 220px) !important;
  min-height: var(--day-height, 220px) !important;
  transition: all 0.3s ease; /* 加个过渡动画，调整高度时更顺滑 */
}

.my-date-picker-wrapper {
  position: relative;
  display: inline-block; /* 让 div 撑开包裹 input */
}

/* 强制覆盖弹框的 left 值 */
body .custom-picker-popper {
  position: absolute;
}

body .custom-picker-popper1{
  position: absolute;
}

.upload-demo{
  display: inline-block;
  margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/page/subPage/SignPlan.vue